import { eye, eyeClosed, genesisIcons } from '@formkit/icons';
import { defaultConfig } from '@formkit/vue';

import { rootClasses } from './formkit.regenesis';

export default defaultConfig({
  config: { rootClasses },
  icons: {
    ...genesisIcons,
    eye,
    eyeClosed,
  },
});
